import "../css/style.scss";
import 'swiper/css/bundle';

import { isMobile } from "./Module/Helper";

import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { init, initBeforeEnter, } from "./Module/init";
import { smooth } from "./Module/smooth-scrollbar/smoothscrollBar";


import { Fancybox } from "@fancyapps/ui";     


if (!isMobile()) smooth(); 


init();
initBeforeEnter();


// Fancybox
Fancybox.bind("[data-fancybox]", {
  // Your custom options
});